module.exports = __webpack_public_path__ + "static/dev-3-559d681383a359e8248f421b67db348d.jpg";